module.exports = __webpack_public_path__ + "static/media/video-3.2cb2cf2d.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/video-3.webm
// module id = 156
// module chunks = 0